import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { EllipsisModule } from 'ngx-ellipsis';
import { SideMenuPageComponent } from './side-menu-page';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    EllipsisModule,
    RouterModule.forChild([
      {
        path: '',
        pathMatch: 'full',
        component: SideMenuPageComponent,
      },
    ]),
  ],
  declarations: [SideMenuPageComponent],
  exports: [SideMenuPageComponent],
})
export class PagesSideMenuModule {}
